"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var StyleButton_1 = require("../style-button/StyleButton");
var theme = require("../../theme.scss");
var BLOCK_TYPES = [
    { label: "H1", style: "header-one" },
    { label: "H2", style: "header-two" },
    { label: "H3", style: "header-three" },
    { label: "H4", style: "header-four" },
    { label: "H5", style: "header-five" },
    { label: "H6", style: "header-six" },
    { label: "Blockquote", style: "blockquote" },
    { label: "UL", style: "unordered-list-item" },
    { label: "OL", style: "ordered-list-item" },
    { label: "Code Block", style: "code-block" },
];
var BlockStyleControls = /** @class */ (function (_super) {
    tslib_1.__extends(BlockStyleControls, _super);
    function BlockStyleControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockStyleControls.prototype.render = function () {
        var _a = this.props, editorState = _a.editorState, onToggle = _a.onToggle;
        var selection = editorState.getSelection();
        var blockType = editorState
            .getCurrentContent()
            .getBlockForKey(selection.getStartKey())
            .getType();
        return (React.createElement("div", { className: theme.editorControls }, BLOCK_TYPES.map(function (type) {
            return React.createElement(StyleButton_1.default, { key: type.label, active: type.style === blockType, label: type.label, onToggle: onToggle, style: type.style });
        })));
    };
    return BlockStyleControls;
}(React.Component));
exports.default = BlockStyleControls;
